/**
 * Constantes centralisées pour la configuration de la carte
 * Source unique de vérité pour le frontend
 */

export const DEFAULT_MAP_CENTER: [number, number] = [48.8566, 2.3522]; // Paris
export const DEFAULT_MAP_ZOOM = 12;
export const DEFAULT_TILE_SIZE = 256;

/**
 * Limites géographiques
 */
export const GEO_BOUNDS = {
  minLatitude: -90,
  maxLatitude: 90,
  minLongitude: -180,
  maxLongitude: 180,
} as const;

/**
 * Configuration des tuiles OpenStreetMap par défaut
 */
export const DEFAULT_TILE_CONFIG = {
  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: '© OpenStreetMap contributors',
  minZoom: 0,
  maxZoom: 19,
  tileSize: 256,
} as const;

// ============= Symboles d'icônes =============
export const ICON_SYMBOLS = {
  marker: '📍',
  monument: '🏛️',
  church: '⛪',
  restaurant: '🍽️',
  hotel: '🏨',
  park: '🌳',
  museum: '🏛️',
  shop: '🛍️',
  hospital: '🏥',
  school: '🏫',
  bank: '🏦',
  gas: '⛽',
  parking: '🅿️',
  info: 'ℹ️',
  warning: '⚠️',
  star: '⭐',
  home: '🏠',
  office: '🏢',
} as const;

export type IconSymbolKey = keyof typeof ICON_SYMBOLS;

// ============= Tailles d'icônes =============
export const ICON_SIZES = {
  small: { size: 20, font: '12px' },
  medium: { size: 30, font: '16px' },
  large: { size: 40, font: '20px' },
} as const;

export type IconSizeKey = keyof typeof ICON_SIZES;

// ============= Style par défaut =============
export const DEFAULT_MARKER_STYLE = {
  couleur: '#FF5733',
  icone: 'marker' as IconSymbolKey,
  taille: 'medium' as IconSizeKey,
} as const;

// Default size in px for image-based markers
export const DEFAULT_MARKER_IMAGE_SIZE = 40;
